import React, { useState } from 'react';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faLock } from '@fortawesome/fontawesome-free-solid';
import logo_vnpt from 'assets/imgs/logo_home.png';
import telephone from 'assets/imgs/telephone_2.png';
import icon_4g from 'assets/imgs/4g_icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { I18nService, InputText, KCSModal, Notification } from 'components';
import { Button, Modal } from 'react-bootstrap';
import { UserService } from 'services/UserService';
import { FormattedMessage, useIntl } from 'react-intl';
import Signup from './Component/Signup';
import ForgotPassword from './Component/ForgotPassword';
import ResetPassword from './Component/ResetPassword';
import { useHistory } from 'react-router-dom';
import { URL_LOGIN_3G } from 'global/environment';
import { doLogin } from 'store/action/userAction';
import { CommonService } from 'services/CommonService';

const md5Hex = require('md5-hex');

const Login = ({ isOpenModalLogin, closeModalLogin, showDes, message="" }) => {
  const [step, setStep] = useState(0);
  const [tab, setTab] = useState(0);
  const [otp, setOtp] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [renewPassword, setRenewPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [errorMsg2, setErrorMsg2] = useState('');
  const [isOpenModal, setOpenModal] = useState(false);
  const [content, setContent] = useState('');
  const {FCMToken} = useSelector(state => state.authorizedReducer);

  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();

  const handlePhoneNumber = (value) => {
    setPhoneNumber(value)
    const test = CommonService.REGEX_PHONE_NUMBER.test(value);
    if (!test || value.length > 11) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }));
    } else {
      setErrorMsg('')
    }
  }

  const isDisabled = () => {
    return errorMsg || phoneNumber.length === 0;
  }

  const loginByPass = () => {
    if (!phoneNumber) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_SNHAPSODIENTHOAI' }));
    } else {
      setStep(2);
    }
  }

  // const onBack = () => {
  //   if (step === 1 || step === 2) {
  //     setStep(0);
  //   } else {
  //     setStep(step - 1);
  //   }
  //   setOtp('')
  // }

  const sendOTP = (isForgotPassword) => {
    if (isDisabled()) {
      return;
    }
    const data = {
      // for_test: '84824888193',
      msisdn: phoneNumber,
      otp_service: isForgotPassword === true ? "authen_miss_password" : "authen_msisdn"
    };

    UserService.sendOTP(data, res => {
      if (res.error_code === '0') {
        Notification.success(res.message || intl.formatMessage({ id: 'IDS_SEND_OTP_SUCCESS' }));
        if (isForgotPassword !== true) {
          setStep(1);
        } else if (step === 3) {
          setStep(4);
        }
      } else {
        Notification.error(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
      }
    }, (res) => {
      Notification.error(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
    });
  }

  const handleLogin = (mode) => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) 
    {
        userAgent = 'Opera';
    }
    else if(navigator.userAgent.indexOf("Edg") != -1 )
    {
        userAgent = 'Edge';
    }
    else if(navigator.userAgent.indexOf("Chrome") != -1 )
    {
        userAgent = 'Chrome';
    }
    else if(navigator.userAgent.indexOf("Safari") != -1)
    {
        userAgent = 'Safari';
    }
    else if(navigator.userAgent.indexOf("Firefox") != -1 ) 
    {
         userAgent = 'Firefox';
    }
    else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
    {
      userAgent = 'IE'; 
    }  
    else 
    {
       userAgent = 'unknown';
    }
    
    //eku_3_FcQvU:APA91bGMDX0optWjFWpkkdpKjasD44RYPaIYsvVilyPub1Tq2DV41G75NvmHk09ZIm_qFtUzN5iSj4wcN7BiG-xpSsuTKJOucCERqcIY0L9ogfqBFJqm6waBaE8GA6EYmPpYNWDpF1g4
    const data = {
      device_info: userAgent,
      fcm_registration_token: FCMToken,
      mode: mode,
      msisdn: phoneNumber,
      password: mode === 'otp' ? otp : md5Hex(password)
    };

    if (mode === 'password' && !password) {
      setErrorMsg2(intl.formatMessage({ id: 'IDS_VALIDATION_VPLUS_USERNAME_LENGTH' }));
      return;
    }

    UserService.login(data, res => {
      if (res.error_code === '0') {
        localStorage.setItem('mobile', res.msisdn);
        localStorage.setItem('session', res.session);
        localStorage.setItem('authorized', true);
        dispatch(doLogin());
        closeModalLogin();
        Notification.success(res.message || intl.formatMessage({ id: 'IDS_LOGIN_OTP_SUCCESS' }));
      } else {
        setOpenModal(true);
        setContent(res.message || intl.formatMessage({ id: 'IDS_LOGIN_FAILED' }));
      }
    }, (res) => {
      setOpenModal(true);
      setContent(res.message || intl.formatMessage({ id: 'IDS_LOGIN_FAILED' }));
    });
  }

  const changePassword = () => {
    const data = {
      otp: otp,
      msisdn: phoneNumber,
      password: md5Hex(newPassword)
    };

    UserService.missPassword(data, res => {
      if (res.error_code === '0') {
        Notification.success(intl.formatMessage({ id: 'IDS_TV_DOI_MAT_KHAU_THANH_CONG' }));
        closeModalLogin();
        return;
      }
      setContent(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
      setOpenModal(true);
    });
  }

  const onLogin3G = () => {
    window.location.href = `${URL_LOGIN_3G}${history.location.pathname}${history.location.search}`;
  }
  let messageStr = message
  if (messageStr === "" || messageStr === undefined) {
    messageStr = intl.formatMessage({ id: 'IDS_LOGIN_DESCRIPTION' })
  }
  // STEP = 0
  const loginActionScreen = () => {
    return (
      <div>
        {showDes && <p className="red mb-3 text-center">{messageStr}</p>}
        <div className="position-relative">
          <FontAwesomeIcon
            color="#007bff"
            icon={faMobileAlt}
            size="2x"
            className="login__icon-mobile"
          />
          <InputText
            value={phoneNumber}
            handleOnChange={handlePhoneNumber}
            placeholder={intl.formatMessage({ id: 'IDS_TV_REQUEST_PHONE_NUMBER' })}
            errorMsg={errorMsg}
            onlyNumber
            onEnter={sendOTP}
          />
        </div>
        <Button disabled={isDisabled()} className="login__btn" onClick={sendOTP}>
          <FormattedMessage id='IDS_TV_LOGINNEW_GUIOTP' /></Button>
        <div className="login__or-text"><span><FormattedMessage id='IDS_SLOGINOR' /></span></div>
        <div className="login__by-pass margin-top-20 pointer" onClick={loginByPass}>
          <FormattedMessage id='IDS_SLOGINMK' /></div>

        <div className="d-lg-none">
          <div className="login__3g-btn" onClick={onLogin3G}>
            <img alt="4g" src={icon_4g} />
            <FormattedMessage id='IDS_LOGIN_BY_3G' />
          </div>
        </div>
      </div>
    );
  }

  // STEP = 1
  const confirmOTPScreen = () => {
    const phoneSlice = phoneNumber?.slice(0, -3) + 'xxx';

    return (
      <div className="login__confirm">
        <div className="phone-icon mb-4">
          <img alt="phone" src={telephone} />
          <span>{phoneSlice}</span>
        </div>
        <InputText
          value={otp}
          handleOnChange={(value) => setOtp(value)}
          placeholder={intl.formatMessage({ id: 'IDS_TV_FORM_OTP' })}
          onEnter={() => handleLogin('otp')}
          onlyNumber
        />

        <Button className="login__btn mt-4" onClick={() => handleLogin('otp')}>
          <FormattedMessage id='IDS_TV_SIGN_IN' />
        </Button>
        <div className="login__sign-up margin-top-20">
          {I18nService('IDS_SRESENDOTP', { intl, onClick: sendOTP })}
        </div>
      </div>
    )
  };

  // STEP = 2
  const loginPasswordScreen = () => (
    <div className="login__confirm position-relative">
      <FontAwesomeIcon
        color="#007bff"
        icon={faLock}
        size="lg"
        className="login__icon-mobile"
      />
      <InputText
        value={password}
        handleOnChange={(value) => setPassword(value)}
        onEnter={() => handleLogin('password')}
        placeholder={intl.formatMessage({ id: 'IDS_VPLUS_SIGNUP_PASSWORD' })}
        errorMsg={errorMsg2}
        isPassword
      />
      <div className="login__by-pass pointer mt-2" onClick={() => setStep(3)}>
        <FormattedMessage id='IDS_TV_FORGET_PASSWORD' /></div>
      <Button className="login__btn mt-4" onClick={() => handleLogin('password')}>
        <FormattedMessage id={'IDS_TV_SIGN_IN'} />
      </Button>
    </div>
  )

  return (
    <>
      <Modal show={isOpenModalLogin} onHide={closeModalLogin}
        className={`login ${isOpenModal ? 'is-blurred' : ''}`}>
        <Modal.Header closeButton>
          {/* {step !== 0 &&
            <FontAwesomeIcon
              color="#004f9e"
              onClick={onBack}
              className="login__arrow"
              icon={faArrowLeft}
              size="lg"
            />
          } */}
        </Modal.Header>

        <Modal.Body className="login__content">
          <div className="text-center">
            <img alt="logo" src={logo_vnpt} className="login__logo" />
          </div>
          <div className="login__tab">
            <h3 className={tab === 0 ? 'tab-active' : ''} onClick={() => setTab(0)}>
              <FormattedMessage id='IDS_TV_SIGN_IN' /></h3>
            <h3 className={tab === 1 ? 'tab-active' : ''} onClick={() => setTab(1)}>
              <FormattedMessage id='IDS_SDANGKY' /></h3>
          </div>

          {tab === 0 &&
            <>
              {step === 0 && loginActionScreen()}
              {step === 1 && confirmOTPScreen()}
              {step === 2 && loginPasswordScreen()}
              {step === 3 &&
                <ForgotPassword
                  phoneNumber={phoneNumber}
                  handlePhoneNumber={handlePhoneNumber}
                  errorMsg={errorMsg}
                  sendOTP={sendOTP}
                  intl={intl}
                />
              }
              {step === 4 &&
                <ResetPassword
                  otp={otp}
                  setOtp={setOtp}
                  newPassword={newPassword}
                  setNewPassword={setNewPassword}
                  renewPassword={renewPassword}
                  setRenewPassword={setRenewPassword}
                  changePassword={changePassword}
                  intl={intl}
                />
              }
            </>
          }
          {tab === 1 && <Signup closeModalLogin={closeModalLogin} />}

        </Modal.Body>
      </Modal>

      <KCSModal
        isOpenModal={isOpenModal}
        title="Thông báo"
        content={content}
        closeModal={() => setOpenModal(false)}
      />
    </>
  );
}

export default React.memo(Login);
